export const handleOnKeyPress = function (event) {
  let onKeyPress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  let maxCharCount = arguments.length > 2 ? arguments[2] : undefined;
  let value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  const code = 'charCode' in event ? event.charCode : event.keyCode;
  if (maxCharCount && value?.length === maxCharCount && code >= 32 && code <= 126) {
    return event.preventDefault();
  }
  onKeyPress(event);
};